<template>
  <div class="shutdown content">
    <h1>We lost 😭</h1>
    <p>The European Parliament today chose to <a href="https://www.create.ac.uk/wp-content/uploads/2019/03/Academic_Statement_Copyright_Directive_24_03_2019.pdf" target="_blank">ignore copyright experts</a>, <a href="https://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=24298&LangID=E" target="_blank">the UN Special Rapporteur on freedom of expression</a>, and most importantly <b><a href="https://change.org/p/european-parliament-stop-the-censorship-machinery-save-the-internet" target="_blank">your&nbsp;voice</a></b> and voted in favor of upload filters and #Article 13. This is a sad day for the internet, but we'll keep up the fight.</p>
    <div class="select-country">
      <label>This is how the representatives<br>who joined the pledge actually voted:</label>
      <select
        v-model="globalCountry">
        <option
          :value="country[0]"
          v-for="country in countries"
          v-bind:selected="country[0] === globalCountry">
          {{ country[1] }}
        </option>
      </select>
    </div>

    <p
      :class="{ hidden: !error.isShown }"
      class="error">{{ error.text }}</p>
    <transition-group tag="div" name="representative" class="grid-representatives">
      <div
        v-for="representative in goodRepresentatives"
        :key="representative.id"
        v-on:click="selectMEP(representative.id)"
        :class="{
          traitor: representative.vote_amendments !== 'yes' || representative.vote_trilogue !== 'no',
          absent: representative.vote_amendments === 'not_there' || representative.vote_trilogue === 'not_there'
        }"
        class="grid-representative" >
        <p class="name">{{ representative.name }}</p>
        <p class="party">{{ representative.national_party }}</p>
        <span
          :class="{
            yes: representative.vote_amendments === 'yes',
            no: representative.vote_amendments === 'no',
            abstain: representative.vote_amendments === 'abstain',
            not_there: representative.vote_amendments === 'not_there',
          }"
          class="vote-am"
          :title="voteAmendments(representative)">
        </span>
        <span
          :class="{
            yes: representative.vote_trilogue === 'yes',
            no: representative.vote_trilogue === 'no',
            abstain: representative.vote_trilogue === 'abstain',
            not_there: representative.vote_trilogue === 'not_there',
          }"
          class="vote-trilogue"
          :title="voteTrilogue(representative)"></span>
      </div>
    </transition-group>
    <infinite-loading
      class="infinite-loading"
      :identifier="globalCountry"
      @infinite="fetchMEPs">
      <div slot="no-more"></div>
      <p slot="no-results" v-if="representatives.length === 0" class="small">{{ $t('components.representatives.none')}}</p>
      <p slot="no-results" v-if="representatives.length > 0" class="small"></p>
    </infinite-loading>

    <div class="not-pledged">
      <h2>Representatives from these parties did not pledge:</h2>
      <ul>
        <li
          v-for="party in unfriendlyParties"
          :key="party"
          class="parties" >
          {{ party.name }}
        </li>
      </ul>
    </div>

    <p>You can find out how the rest of the politicians from your country voted in <a href="https://juliareda.eu/wp-content/uploads/2019/03/copyrightvote.pdf" target="_blank">this list of results</a>. You can also check out the <a href="https://archive.pledge2019.eu">Pledge2019.eu campaign website (archived)</a>.</p>

    <SectionNewsletter />
    <p>This campaign was run by the Austrian digital rights NGO <a href="https://epicenter.works" target="_blank">epicenter.works</a> together with partner organizations from across Europe. Despite a smear campaign against our actions to enable <b>you</b> to connect with parliamentarians, we did not receive a cent from Google or other web giants.</p>
    <p class="last">Please help us fight for your digital rights in the future as well:</p>
    <a href="https://support.epicenter.works"><button>Donate now!</button></a>
  </div>
</template>

<script>
import RepresentativePhoto from '@/components/SectionCalling/RepresentativePhoto.vue'
import SectionNewsletter from '@/components/SectionNewsletter'
import InfiniteLoading from 'vue-infinite-loading'
import CountriesMixin from '../mixins/CountriesMixin'
import { resolveJSON } from '@/helperfunctions'

export default {
  name: 'Shutdown',
  components: {
    SectionNewsletter,
    InfiniteLoading,
    RepresentativePhoto,
  },
  mixins: [CountriesMixin],
  data: function() {
    return {
      representatives: [],
      unfriendlyParties: [],
      error: {
        isShown: false,
        text: '',
      }
    }
  },
  computed: {
    globalCountry: {
      get: function() {
        return this.$root.country
      },
      set: function(country) {
        this.$root.country = country
      }
    },
    goodRepresentatives () {
      return this.representatives.filter(representative => representative.friendly)
    },
  },
  watch: {
    '$root.country': 'flushMEPs',
  },
  methods: {
    voteAmendments(representative) {
      switch (representative.vote_amendments) {
        case 'yes':
          return 'Voted in favour of allowing amendments'
          break
        case 'no':
          return 'Voted against allowing amendments'
          break
        case 'abstain':
          return 'Abstained on allowing amendments'
          break
        case 'not_there':
          return 'Not present at the vote'
          break
      }
    },
    voteTrilogue(representative) {
      switch (representative.vote_trilogue) {
        case 'yes':
          return 'Voted for trilogue agreement'
          break
        case 'no':
          return 'Voted against trilogue agreement'
          break
        case 'abstain':
          return 'Abstained on trilogue agreement'
          break
        case 'not_there':
          return 'Not present at the vote'
          break
      }
    },
    flushMEPs() {
      this.representatives = []
      this.unfriendlyParties = []
      this.fetchMEPs()
    },
    selectMEP(id) {
      const selectedMEP = this.representatives.find(representative => representative.id === id)
      this.$root.mep = selectedMEP
      this.$scrollTo('#calling')
    },
    fetchMEPs($state) {
      this.error.text = ''
      this.error.isShown = false

      fetch(`/api/meps/?country=${this.$root.country}&range=[0,100]`)
        .then(resolveJSON)
        .then(json => {
          const deduplicatedJson = json.filter(mep => !this.representatives.find(representative => mep.id === representative.id))
          const friendlyJson = deduplicatedJson.filter(mep => mep.friendly === true)
          this.representatives.push(...friendlyJson)
          this.representatives = this.representatives.sort((a,b) => a.national_party < b.national_party ? -1 : 1)
          if ($state) {
            if (json.length) {
              $state.loaded()
            } else {
              $state.complete()
            }
          }
          const unfriendlyJson = deduplicatedJson.filter(mep => mep.friendly === false)
          const unfriendlyParties = []
          unfriendlyJson.map(mep => {
            if (!unfriendlyParties.find(party => party.name === mep.national_party)) {
              unfriendlyParties.push({'name': mep.national_party, 'count': 1})
            } else {
              unfriendlyParties.find(party => party.name === mep.national_party).count++
            }
          })
          this.unfriendlyParties = unfriendlyParties.sort((a,b) => a.count < b.count ? 1 : -1)
        })
        .catch(error => {
          this.error.text = error.message
          this.error.isShown = true
        })
    },
  }
}
</script>

<style lang=scss scoped>
.shutdown {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: justify;

  h1 {
    font-size: 5em;
    line-height: 1em;

  }
  p {
    max-width: 768px;
    margin-bottom: 0;
  }
  button {
    margin-bottom: 1em;
  }

  .not-pledged {
    width: 100%;
    max-width: 768px;
    text-align: left;

    h2 {
      font-size: 1em;
      margin: 2em 0 0.5em;
    }

    ul {
      margin: 0;
      li {
        margin: 0;
      }
    }
  }

  .select-country {
    width: 100%;
    max-width: 768px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    margin: 1em 0 0.5em;

    label {
      font-weight: bold;
    }

    select {
      background-color: white;
      font-size: 1em;
      font-family: 'Work Sans', sans-serif;
    }
  }

  .grid-representatives {
    width: 100%;
    max-width: 768px;
    .grid-representative {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin: 0.2em;
      }
      .name {
        flex: 1;
      }
      .party {
        text-align: right;
        font-size: 0.8em;
      }
      .vote-am, .vote-trilogue {
        width: 20px;
        height: 20px;
        margin: 0.2em;
        border-radius: 50%;
        box-shadow: 0 0 10px 1px rgba(0,0,0,0.1);
        cursor: help;
        flex-shrink: 0;
      }
      .vote-am.yes, .vote-trilogue.no {
        background-color: #28a745;
      }
      .vote-am.no, .vote-trilogue.yes {
        background-color: #dc3545;
      }
      .vote-am.abstain, .vote-trilogue.abstain {
        background-color: #ffc107;
      }
      .vote-am.not_there, .vote-trilogue.not_there {
        background-color: #6c757d;
      }
    }
    .grid-representative:nth-child(2n+1) {
      background-color: rgba(0,0,0,0.1);
    }
    .grid-representative.traitor {
      background-color: rgb(200,0,0);
      color: white;
    }
    .grid-representative.absent {
      background-color: #ccc !important;
      color: black !important;
    }
  }
}
</style>
